import { useMemo } from 'react'

import { useRealtimeStore } from '../store/realtime-store'
import type { Job, Worker } from '../types'

/** Ordered workers from the normalized store; stable while nothing changes. */
export function useWorkers(): Worker[] {
  const workersById = useRealtimeStore((state) => state.workersById)
  const workerIds = useRealtimeStore((state) => state.workerIds)
  return useMemo(
    () => workerIds.map((id) => workersById[id]).filter((worker): worker is Worker => Boolean(worker)),
    [workerIds, workersById],
  )
}

/** Jobs ordered by scheduled start; stable while nothing changes. */
export function useJobs(): Job[] {
  const jobsById = useRealtimeStore((state) => state.jobsById)
  const jobIds = useRealtimeStore((state) => state.jobIds)
  return useMemo(
    () => jobIds.map((id) => jobsById[id]).filter((job): job is Job => Boolean(job)),
    [jobIds, jobsById],
  )
}

export function useHighlightedJobs(): Record<string, number> {
  return useRealtimeStore((state) => state.highlightedJobs)
}
